(($) => {
  $(() => {
    const $modal = $('#video-player-modal');

    if ($modal.length) {
      const $iframe = $modal.find('iframe');

      $modal.on({
        'show.bs.modal': (e) => {
          const $relatedTarget = $(e.relatedTarget);

          $iframe.attr({
            src: $relatedTarget.data('video-src'),
          });
        },
        'hide.bs.modal': () => {
          $iframe.removeAttr('src');
        },
      });
    }
  });
})(jQuery);
